import config from "../config";

const crypto = require("crypto-js");

export default class DataHandlerService {
  cipher = config.cipher;

  setUserSession(token) {
    const cipherText = crypto.AES.encrypt(JSON.stringify(token), this.cipher).toString();
    localStorage.setItem("ustk", cipherText);
  }

  setUserData(data) {
    const cipherText = crypto.AES.encrypt(JSON.stringify(data), this.cipher).toString();
    localStorage.setItem("udt", cipherText);
  }

  encrypt(data) {
    return crypto.AES.encrypt(JSON.stringify(data), this.cipher).toString().replace(/\//g, '*').replace(/\=/g, '+*');
  }

  decrypt(data) {
    data = data.replace(/\*/g, '/').replace(/\+*/g, '=');
    return crypto.AES.decrypt(data, this.cipher).toString(crypto.enc.Utf8);
  }

  getUserSession() {
    let ustk = localStorage.getItem("ustk");
    if (ustk) {
      ustk = crypto.AES.decrypt(ustk, this.cipher).toString(crypto.enc.Utf8);

      ustk = ustk.replace(/\"/g, "");
      return ustk;
    } else {
      return null;
    }
  }

  getUserData() {
    let udt = localStorage.getItem("udt");
    if (udt) {
      udt = crypto.AES.decrypt(udt, this.cipher).toString(crypto.enc.Utf8);
      const _udt = JSON.parse(udt);
      return _udt;
    } else {
      return null;
    }
  }

  setHeader() {
    const header = {};
    const token = this.getUserSession();
    header["user_session_token"] = token;
    return header;
  }
}
